import {
  Component,
  HostBinding,
  Input,
  AfterContentInit,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { Button } from './button.directive';

@Component({
  selector: 'suka-button-group',
  template: `<div class="btn-group__wrapper"><ng-content></ng-content></div>`
  })
export class ButtonGroup implements AfterContentInit {
  @HostBinding('class.btn-group') baseClass = true;

  /**
   * 	Join buttons as segmented group
   */
  @HostBinding('class.btn-group--segmented') @Input() segmented: boolean;

  @ContentChildren(Button) buttons: QueryList<Button>;

  ngAfterContentInit() {
    this.buttons.toArray().forEach((button: Button) => {
      button.inGroup = true;
    });
  }
}
